//import library
import "bootstrap-select";
import "bootstrap-select/dist/css/bootstrap-select.min.css";

export default {
  init(element) {
    $.fn.selectpicker.Constructor.BootstrapVersion = "4";
    $(element).selectpicker();
  },
};
